import artSeoConfig from './art';
import gedolimSeoConfig from './gedolim';
import theClassicsSeoConfig from './the_classics';
import jewishIconsSeoConfig from './jewish_icons';
import aroundTheHomeSeoConfig from './around_the_home';
import mezuzahSeoConfig from './mezuzah';
import namePlatesSeoConfig from './name_plates';
import judaicaSeoConfig from './judaica';
import signsSeoConfig from './signs';

// Order matters: more specific matches must come before general ones (art, judaica)
const configs = [signsSeoConfig, gedolimSeoConfig, theClassicsSeoConfig, jewishIconsSeoConfig, aroundTheHomeSeoConfig, artSeoConfig, mezuzahSeoConfig, namePlatesSeoConfig, judaicaSeoConfig];

/**
 * Find the SEO config that matches the current search page context.
 * Returns null when no category-specific SEO applies.
 */
export const getSeoConfig = ({ listingType, activeCollection, activeJudaicaCollection, collectionSlug }) =>
  configs.find(c =>
    c.match({ listingType, activeCollection, activeJudaicaCollection, collectionSlug })
  ) ?? null;

/**
 * Build the page-level override (title, description, schema) from a config.
 * Returns null when no config is provided.
 */
export const getPageOverride = (seoConfig, rootURL) => {
  if (!seoConfig) return null;
  return {
    title: seoConfig.title,
    description: seoConfig.description,
    schema: seoConfig.getSchema(rootURL),
  };
};
